import {
	listResourceQueryDefinitions,
	viewResourceQueryDefinitions,
	createResourceMutationDefinitions,
	updateResourceMutationDefinitions,
	deleteResourceMutationDefinitions
} from '@/providers/graphql/resourceQueryDefinitions';
import gql from 'graphql-tag';

export const VOUCHERS_LIST_QUERY = gql`
	query Vouchers($first: Int, $after: String) {
		vouchers(first: $first, after: $after) {
			nodes {
				voucherId
				name
				code
				isAdHoc
				isCustomerSpecific
				discountValue
				maxDiscountAmount
				usageLimit
				currentUsageCount
				isActive
				validUntilDate
				voucherDiscountType {
					voucherDiscountTypeId
					name
				}
				campaign {
					campaignId
					name
				}
				customer {
					customerId
					firmName
					email
				}
			}
			pageInfo {
				hasNextPage
				endCursor
			}
		}
	}
`;

export const VOUCHER_LIST_ITEM_QUERY = gql`
	query VoucherListItem($voucherId: Ulid!) {
		voucher(voucherId: $voucherId) {
			voucherId
			code
			name
			isAdHoc
			isCustomerSpecific
			discountValue
			maxDiscountAmount
			usageLimit
			currentUsageCount
			isActive
			validUntilDate
			voucherDiscountType {
				voucherDiscountTypeId
				name
			}
			campaign {
				campaignId
				name
			}
		}
	}
`;

export const VOUCHER_QUERY = gql`
	query Voucher($voucherId: Ulid!) {
		voucher(voucherId: $voucherId) {
			voucherId
			campaignId
			facilityId
			name
			code
			isAdHoc
			isCustomerSpecific
			customerId
			tariffBindingRequired
			tariffId
			voucherDiscountTypeId
			discountValue
			maxDiscountAmount
			usageLimit
			currentUsageCount
			isActive
			dateUsed
			validUntilDate
			campaign {
				campaignId
				name
			}
			customer {
				customerId
				firmName
				email
			}
			tariff {
				tariffId
				name
			}
			voucherDiscountType {
				voucherDiscountTypeId
				name
				description
			}
		}
	}
`;

export const VOUCHER_CREATE_MUTATION = gql`
	mutation CreateVoucher($input: CreateVoucherInput!) {
		createVoucher(input: $input) {
			success
			errorCode
			errorDescription
			isErrored
			failed
		}
	}
`;

export const VOUCHER_UPDATE_MUTATION = gql`
	mutation UpdateVoucher($input: UpdateVoucherInput!) {
		updateVoucher(input: $input) {
			success
			errorCode
			errorDescription
			isErrored
			failed
		}
	}
`;

export const VOUCHER_DELETE_MUTATION = gql`
	mutation DeleteVoucher($input: DeleteVoucherInput!) {
		deleteVoucher(input: $input) {
			success
			errorCode
			errorDescription
			isErrored
			failed
		}
	}
`;

listResourceQueryDefinitions['vouchers'] = {
	document: VOUCHERS_LIST_QUERY,
	dataPath: 'vouchers.nodes'
};

viewResourceQueryDefinitions['vouchers'] = {
	document: VOUCHER_QUERY,
	dataPath: 'voucher'
};

createResourceMutationDefinitions['vouchers'] = {
	document: VOUCHER_CREATE_MUTATION,
	operation: 'createVoucher',
	getVariables: variables => ({ input: variables })
};

updateResourceMutationDefinitions['vouchers'] = {
	document: VOUCHER_UPDATE_MUTATION,
	operation: 'updateVoucher',
	getVariables: variables => ({ input: variables })
};

deleteResourceMutationDefinitions['vouchers'] = {
	document: VOUCHER_DELETE_MUTATION,
	operation: 'deleteVoucher',
	getVariables: variables => ({ input: variables })
};

// Lookup queries for form dropdowns
export const CUSTOMERS_QUERY = gql`
	query Customers {
		customers(first: 50) {
			nodes {
				customerId
				firmName
				email
			}
		}
	}
`;

export const TARIFFS_QUERY = gql`
	query Tariffs {
		tariffs(first: 50) {
			nodes {
				tariffId
				name
			}
		}
	}
`;

export const CUSTOMER_LOOKUP_QUERY = gql`
	query CustomerLookup($where: CustomerViewModelFilterInput) {
		customers(first: 50, where: $where) {
			nodes {
				customerId
				firmName
				email
			}
		}
	}
`;

export const TARIFF_LOOKUP_QUERY = gql`
	query TariffLookup($where: TariffViewModelFilterInput) {
		tariffs(first: 50, where: $where) {
			nodes {
				tariffId
				name
			}
		}
	}
`;

export const VOUCHER_DISCOUNT_TYPES_QUERY = gql`
	query VoucherDiscountTypes {
		vouchers(first: 50) {
			nodes {
				voucherDiscountType {
					voucherDiscountTypeId
					name
					description
				}
			}
		}
	}
`;

export const FACILITIES_QUERY = gql`
	query Facilities {
		facilities(first: 50) {
			nodes {
				facilityId
				name
			}
		}
	}
`;

export const CAMPAIGNS_QUERY = gql`
	query Campaigns {
		campaigns(first: 50) {
			nodes {
				campaignId
				name
				description
			}
		}
	}
`;
